import { Container } from "../../../components";
import { Alert, Card } from "antd";
import React from "react";
export var TestnetWarning = function TestnetWarning() {
  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: false,
    style: gridStyle
  }, /*#__PURE__*/React.createElement(Alert, {
    message: "Testnet Network",
    description: /*#__PURE__*/React.createElement("div", null, "Your Tatum API key is the Testnet network type. It should be used only for testing purposes and NFT minted with this API key dont have any value. If want work with the real Mainnet NFTs buy paid API key plan at", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://dashboard.tatum.io",
      target: "_blank",
      rel: "noreferrer"
    }, "Tatum dashboard.")),
    type: "warning",
    showIcon: true
  }))));
};